module.exports = __webpack_public_path__ + "static/img/0001.733ae823.png";